import BaneNorIcon from './bane-nor-icon';
export default BaneNorIcon;